import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

/**
 * Reusable pill button with a circular arrow that rotates on hover.
 * variant: "orange" | "white" | "blue" | "outline"
 */
const styles = {
  orange: {
    bg: "var(--tnf-orange)",
    text: "#ffffff",
    circleBg: "#ffffff",
    arrow: "var(--tnf-orange)",
    border: "transparent",
  },
  white: {
    bg: "#ffffff",
    text: "#0e0e10",
    circleBg: "var(--tnf-blue)",
    arrow: "#ffffff",
    border: "rgba(0,0,0,0.06)",
  },
  blue: {
    bg: "var(--tnf-blue)",
    text: "#ffffff",
    circleBg: "#ffffff",
    arrow: "var(--tnf-blue)",
    border: "transparent",
  },
  outline: {
    bg: "transparent",
    text: "#0e0e10",
    circleBg: "#0e0e10",
    arrow: "#ffffff",
    border: "rgba(0,0,0,0.16)",
  },
};

const CircleArrowLink = ({
  to,
  href,
  children,
  variant = "orange",
  className = "",
}) => {
  const s = styles[variant] || styles.orange;
  const inner = (
    <>
      <span className="pl-1">{children}</span>
      <span
        className="tnf-arrow w-9 h-9"
        style={{ background: s.circleBg }}
      >
        <ArrowUpRight size={18} color={s.arrow} />
      </span>
    </>
  );
  const cls = `tnf-pill pl-6 pr-1.5 py-1.5 text-[15px] ${className}`;
  const style = {
    background: s.bg,
    color: s.text,
    border: `1px solid ${s.border}`,
  };

  if (href) {
    return (
      <a href={href} className={cls} style={style}>
        {inner}
      </a>
    );
  }
  return (
    <Link to={to} className={cls} style={style}>
      {inner}
    </Link>
  );
};

export default CircleArrowLink;
